<template>
    <div class="age-info" @click.stop.prevent="toggleUpdateAgeDialog">
<!--        <div :title="$translate('oocyte_age')" class="oocyte-age">-->
<!--            <img class="age-icon" src="/static/svg/oocyte.svg" alt="" />-->
<!--            <span v-if="treatment.oocyteAge" class="age-value">-->
<!--                {{ $utils.monthsToYears(treatment.oocyteAge) }}-->
<!--            </span>-->
<!--            <span v-else class="add-age">-->
<!--                {{ $translate('add').toLowerCase() }}-->
<!--            </span>-->
<!--        </div>-->

<!--        <span class="v-divider">|</span>-->

        <div :title="$translate('patient_age')" class="patient-age mr-2">
            <img class="age-icon" src="/static/svg/female.svg" alt="" />
            <span v-if="treatment.patientAge" class="age-value">
                {{ $utils.monthsToYears(treatment.patientAge) }}
            </span>
            <span v-else class="add-age">
                {{ $translate('add').toLowerCase() }}
            </span>
        </div>

        <i class="fa fa-pencil text-light-1 text-size-8 ml-1" />

        <update-age-dialog
            v-if="showEditDialog"
            :treatment="treatment"
            :slide-id="slide ? slide._id : null"
            @ageUpdated="updateTreatment"
            @hide="hideDialog"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import UpdateAgeDialog from './UpdateAgeDialog'

export default {
    name: 'AgeInfo',
    components: { UpdateAgeDialog },
    props: {
        treatment: {
            type: Object,
            required: true
        },
        slide: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        showEditDialog: false
    }),

    methods: {
        toggleUpdateAgeDialog() {
            this.showEditDialog = !this.showEditDialog
        },
        hideDialog() {
            this.showEditDialog = false
        },
        updateTreatment({ oocyteAge, patientAge }) {
            if (oocyteAge) {
                this.treatment.oocyteAge = oocyteAge
            }
            if (patientAge) {
                this.treatment.patientAge = patientAge
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.age-info {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    cursor: pointer;

    .v-divider {
        border: none;
        padding: 0 0.25rem;
    }

    .oocyte-age,
    .patient-age {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }

    .age-icon {
        height: 18px;
        margin-right: 0.5rem;
    }
    .age-value {
        color: $light-3;
    }
    .add-age {
        color: $red;
        font-weight: var(--font-weight-bold);
    }

    .update-age-dialog {
        position: absolute;
        top: calc(100% + 10px);
        right: 0;
    }
}
</style>
